var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _circle2, _rect6, _rect7, _circle3, _rect8, _rect9, _circle4, _rect10, _rect11, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeagueEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.697266,
    width: 102.272,
    height: 102.272,
    rx: 51.136,
    fill: "#CDF1F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 25,
    width: 14,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6973,
    y: 26,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#00223A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6973,
    cy: 27,
    r: 4,
    fill: "#FF6C00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 73,
    width: 14,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6973,
    y: 74,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#00223A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6973,
    cy: 75,
    r: 4,
    fill: "#FF6C00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 61,
    width: 14,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6973,
    y: 62,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#00223A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6973,
    cy: 63,
    r: 4,
    fill: "#FF6C00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 37,
    width: 14,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6973,
    y: 38,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#00223A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6973,
    cy: 39,
    r: 4,
    fill: "#FF6C00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 49,
    width: 14,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6973,
    y: 50,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#00223A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6973,
    cy: 51,
    r: 4,
    fill: "#FF6C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeagueEmpty);
export default __webpack_public_path__ + "static/media/league-empty.b009c2e5db8681642e2f050de618e845.svg";
export { ForwardRef as ReactComponent };